/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { EWidgetCostsChart } from '../../../PageDashboard/components/Widgets/WidgetCosts/types/widgetCostsType';
import { SubscriberIdFinanceConfiguration } from './components/subscriberIdFinancesConstant';
import { IFinanceChart, IFinanceChartItem } from './types';

export interface IFinanceItemChartResponse {
    children?: IFinanceItemChartResponse[];
    id: EWidgetCostsChart;
    label: string;
    value: number;
}

export interface IFinanceChartResponse {
    aggregates: IFinanceItemChartResponse[];
    date: string;
    isDataIncomplete?: boolean;
    totalOfBasicChargesAggregates: number;
}

const subscriberIdFinanceItemMapping = (response: IFinanceItemChartResponse): IFinanceChartItem => ({
    color: SubscriberIdFinanceConfiguration.chart.colors[response.id] || '',
    item: response.label,
    value: response.value,
    children: response.children?.map(subscriberIdFinanceItemMapping) || [],
});

export const subscriberIdFinanceMapping = (response: IFinanceChartResponse): IFinanceChart => {
    const aggregates = response.aggregates?.map(subscriberIdFinanceItemMapping) || [];
    return {
        aggregates,
        date: response.date,
        isDataIncomplete: !!response.isDataIncomplete,
        total: response.totalOfBasicChargesAggregates,
    };
};



